module.exports = __webpack_public_path__ + "static/img/tarjetas.06eab3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tarjetas.png
// module id = mfrM
// module chunks = 1